import { useContext } from 'react'
import { AuthContext } from 'src/context/AuthContext'
import { AuthValuesType } from 'src/context/types'

export const useAuth: () => AuthValuesType = () => useContext(AuthContext)
